/* search-form.js */

// Only define once
if (!customElements.get('search-form')) {
  // Attach class to window so predictive-search.js can extend it
  window.SearchForm = class extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[type="search"]');
      this.resetButton = this.querySelector('button[type="reset"]');

      if (this.input) {
        // Listen for the form's native reset event
        this.input.form.addEventListener('reset', this.onFormReset.bind(this));
        // Debounced input listener for search
        this.input.addEventListener(
          'input',
          debounce((event) => {
            this.onChange(event);
          }, 300).bind(this)
        );
      }
    }

    toggleResetButton() {
      const resetIsHidden = this.resetButton.classList.contains('hidden');
      if (this.input.value.length > 0 && resetIsHidden) {
        this.resetButton.classList.remove('hidden');
      } else if (this.input.value.length === 0 && !resetIsHidden) {
        this.resetButton.classList.add('hidden');
      }
    }

    onChange() {
      this.toggleResetButton();
    }

    shouldResetForm() {
      return !document.querySelector('[aria-selected="true"] a');
    }

    onFormReset(event) {
      // Prevent default so the form reset doesn't set the value from the URL on page load
      event.preventDefault();
      // Don't reset if the user has selected an element in the predictive dropdown
      if (this.shouldResetForm()) {
        this.input.value = '';
        this.input.focus();
        this.toggleResetButton();
      }
    }
  };

  // Register the custom element using the window-based class
  customElements.define('search-form', window.SearchForm);
}